import React from "react";
import en from "@/localization/en.json";

function Question({ question }) {
  return (
    <div className="mb-[1.75rem]">
      <p className="text-[0.875rem] text-[#7B838F] mb-[1.25rem]">
        {en["common.by"]}{" "}
        <span className="text-[#E81E61] mx-[0.5rem]">{question?.customer}</span>
        on {question?.question_date}
      </p>

      <div className="flex items-star  text-[#1F2A3B] space-x-[1.25rem] mb-[1.125rem] font-semibold">
        <p>{en["product.question"]}:</p>
        <p>{question?.question}</p>
      </div>

      <div className="flex items-start  text-[#1F2A3B] space-x-[1.25rem]">
        <p className="font-semibold">{en["product.answer"]}:</p>
        <p className="text-[#1F2A3B]">{question?.answer}</p>
      </div>
    </div>
  );
}

export default Question;
